import React from "react";

import { useTypedOnScroll } from "../../utils/hooks/useTypedOnScroll";
import "./HomeApp.css";

const Insights = () => {
  const [newsInsightsRef] = useTypedOnScroll(
    ["Certilytics News &amp; Insights"],
    { startDelay: 500, typeSpeed: 40 }
  );
  const insightsData = [
    {
      imageUrl: "https://cdn.cloud.certilytics.com/web/himss23blogimage-1.png",
      title: "Hot Topics from our Discussions at HIMSS 2023",
      content:
        "We were thrilled to make new connections and see familiar faces at the HIMSS 2023 conference. Our...",
      link: "#",
    },
    {
      imageUrl: "https://cdn.cloud.certilytics.com/web/CAAemployer-blog.png",

      title: "Three Data Essentials to Turn Compliance Into Opportunity",
      content:
        "With the passing of the Consolidated Appropriations Act of 2021, employers like you were...",
      link: "#",
    },
    {
      imageUrl:
        "https://cdn.cloud.certilytics.com/web/AboutUs-DesktopV2-2023-image-2.jpg",
      title:
        "3 Expert Tips to Help Your Clients Choose the Right Health & Wellness Programs",
      content:
        "Bacon ipsum dolor amet meatloaf biltong ham hock turkey. Brisket ground round pastrami sausage...",
      link: "#",
    },
  ];

  return (
    <section className="home__insights__section w-full h-full flex items-center">
      <div className="container px-5 pb-20 lg:pb-28 2xl:pb-32 pt-16 mx-auto">
        <div className="text-center mb-4 md:mb-8 lg:mb-14">
          {/* <h3 className="hidden lg:block reveal-text text font-semibold text-2xl lg:text-4xl text-center text-dark-blue-background">Certilytics News & Expert Insights</h3> */}
          <h3
            className="hidden lg:block reveal-text text font-semibold text-2xl lg:text-4xl text-center text-dark-blue-background"
            ref={newsInsightsRef}
          ></h3>
        </div>
        <div className="hidden lg:flex flex-wrap -m-4 w-10/12 mx-auto">
          {insightsData.map((card, key) => (
            <div className="px-8 py-0 lg:py-4 sm:w-1/2 lg:w-1/3 lg:transition lg:ease-in-out lg:delay-150 lg:hover:-translate-y-1 lg:hover:scale-105 lg:duration-300">
              <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg">
                <img
                  className="rounded-t-lg md:h-30 lg:h-44 2xl:h-52 w-full object-cover object-center hover:blur-none"
                  src={`${card.imageUrl}`}
                  alt="insights-image-thumbnail"
                  style={{ filter: "blur(1px)" }}
                />
                <div className="insights__card__text md:h-64 lg:h-56 2xl:h-64 flex flex-col justify-between p-4 custom-shadow rounded-b-lg">
                  <div className="line-clamp overflow-hidden">
                    <h3 className="text-base md:text-xl 2xl:text-2xl lg:leading-5 2xl:leading-6 font-semibold mb-3 mt-2 text-dark-blue-background">
                      {card.title}
                    </h3>
                    <div className="mb-0 w-full">
                      <p
                        className="line-clamp-2 leading-5 text-base"
                        style={{ color: "#180f36" }}
                      >
                        {card.content}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center flex-wrap pt-4 pb-3 ">
                    <a
                      href={`${card.link}`}
                      class=" text-dark-blue-background font-semibold cursor-pointer inline-flex items-center md:mb-2 lg:mb-0 underline underline-offset-1  hover:text-primary transition duration-300 ease-in text-xs md:text-sm 2xl:text-base"
                    >
                      Read the Article
                      <svg
                        className="w-3 h-3 md:w-4 md:h-4 ml-1"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Insights;
